import { render } from "./RegulatoryAgentChat.vue?vue&type=template&id=9eee0dc8&scoped=true"
import script from "./RegulatoryAgentChat.vue?vue&type=script&lang=js"
export * from "./RegulatoryAgentChat.vue?vue&type=script&lang=js"

import "./RegulatoryAgentChat.vue?vue&type=style&index=0&id=9eee0dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eee0dc8"]])

export default __exports__